import { z } from 'zod';

export const CMSSEOSchema = z.object({
  seo_page_title: z.string().nullable(),
  seo_description: z.string().nullable(),
  seo_keywords: z.string().nullable(),
});

export type CMSSEOResponse = z.infer<typeof CMSSEOSchema>;
